import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {RacunDocument} from "./RacunDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {PredracunDocument} from "./PredracunDocument";
import {racunDocumentFields} from "./RacunDocumentFields";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor, datum valute, iznos
// opciono: opis, lista priloga, tekući račun

export const predracunDocumentFields: IntercateKeysMap<PredracunDocument, EntityField<PredracunDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	dueDate: {
		name: "dueDate", dataType: EntityFieldDataType._date, label: "Datum valute",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	amount: {
		name: "amount", dataType: EntityFieldDataType._number, label: "Iznos",
		validator: { required: true },
		sortable: true
	},
	accountNumber: {
		name: "accountNumber", dataType: EntityFieldDataType._string, label: "Broj tekućeg računa",
		validator: { required: false },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
};

const documentFieldsArray: Array<EntityField<PredracunDocument>> = [
	predracunDocumentFields.indexingNumber,
	predracunDocumentFields.indexingDate,
	predracunDocumentFields.documentNumber,
	predracunDocumentFields.documentDate,
	predracunDocumentFields.assignedTo,
	predracunDocumentFields.clientId,
	predracunDocumentFields.sectorId,
	predracunDocumentFields.dueDate,
	predracunDocumentFields.amount,
	predracunDocumentFields.accountNumber,
	predracunDocumentFields.tags,
	predracunDocumentFields.description,
	predracunDocumentFields.parentId
];

export const predracunDocumentFieldsDescriptor: EntityFieldsDescriptor<PredracunDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
